import { Tabs, Page, Card, Box } from "@shopify/polaris";
import { useState, useCallback } from "react";
import ReviewsComponent from "../../Components/ReviewsComponent.js";
import SessionsListComponent from "../../Components/SessionsListComponent.js";
import SubscribersComponent from "../../Components/SubscribersComponent.js";

const Subscribers = () => {
  const [selected, setSelected] = useState(0);

  const handleTabChange = useCallback(
    (selectedTabIndex) => setSelected(selectedTabIndex),
    []
  );

  const tabs = [
    {
      id: "expired-subscriptions",
      content: "Expired Subscriptions",
    },
    {
      id: "active-subscriptions",
      content: "Active Subscriptions",
    },
  ];

  return (
    <Page title="Subscriptions" fullWidth>
      <Card padding={0}>
        <Tabs tabs={tabs} selected={selected} onSelect={handleTabChange} fitted>
          {selected === 0 ? (
            <SubscribersComponent type="expired" />
          ) : (
            <SubscribersComponent type="active" />
          )}
        </Tabs>
      </Card>
    </Page>
  );
};

export default Subscribers;
